// ── Dependency Graph — hero background animation ─────────
(function() {
  var canvas = document.getElementById('hero-canvas');
  if (!canvas) { return; }
  var ctx = canvas.getContext('2d');
  var dpr = window.devicePixelRatio || 1;
  var w, h;

  // --- Constants ---
  var LABELS = ['app','router','api','auth','db','cache','config',
                'logger','queue','cron','mail','storage','search',
                'metrics','i18n','ssr','ws','cdn','test','build'];
  var NODE_W = 48, NODE_H = 22, NODE_R = 4;
  var PAD_X = 0.15, PAD_Y = 0.12;
  var BUILD_STAGGER = 300;
  var NODE_APPEAR = 400;
  var EDGE_DRAW = 350;
  var HOLD_MS = 3000;
  var FADE_MS = 1500;

  // --- State ---
  var nodes = [], edges = [], bfsOrder = [];
  var phase = 'GENERATE';
  var phaseStart = 0;
  var globalAlpha = 1;
  var lastTime = 0;

  function resize() {
    var rect = canvas.getBoundingClientRect();
    w = rect.width;
    h = rect.height;
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(dpr, dpr);
  }

  function maxNodes() {
    return w < 600 ? 10 : (w < 900 ? 14 : 18);
  }

  function nodeWidth() {
    return w < 600 ? 36 : NODE_W;
  }

  // --- Tree generation ---
  function generateTree() {
    var target = Math.floor(Math.random() * (maxNodes() - 8)) + 8;
    var pool = LABELS.slice();
    // shuffle pool
    for (var i = pool.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = pool[i]; pool[i] = pool[j]; pool[j] = tmp;
    }

    nodes = [];
    edges = [];
    bfsOrder = [];

    // root
    nodes.push({
      id: 0, label: pool[0], parentId: -1, children: [],
      depth: 0, x: 0, y: 0, opacity: 0, scale: 0.5
    });
    var queue = [0];
    var count = 1;

    while (queue.length > 0 && count < target) {
      var pid = queue.shift();
      var numChildren = Math.min(
        Math.floor(Math.random() * 3) + 1,
        target - count
      );
      // reduce branching at deeper levels
      if (nodes[pid].depth >= 3) {
        numChildren = Math.min(numChildren, 1);
      }
      for (var c = 0; c < numChildren && count < target; c++) {
        var child = {
          id: count,
          label: pool[count % pool.length],
          parentId: pid,
          children: [],
          depth: nodes[pid].depth + 1,
          x: 0, y: 0,
          opacity: 0, scale: 0.5
        };
        nodes.push(child);
        nodes[pid].children.push(count);
        edges.push({ from: pid, to: count, progress: 0, cross: false });
        queue.push(count);
        count++;
      }
    }

    // add 1-2 cross edges
    var crossCount = Math.floor(Math.random() * 2) + 1;
    for (var ce = 0; ce < crossCount; ce++) {
      if (nodes.length < 5) { break; }
      var a = Math.floor(Math.random() * (nodes.length - 2)) + 1;
      var b = Math.floor(Math.random() * (nodes.length - 2)) + 1;
      if (a !== b && Math.abs(nodes[a].depth - nodes[b].depth) <= 1 && nodes[a].parentId !== b && nodes[b].parentId !== a) {
        edges.push({ from: a, to: b, progress: 0, cross: true });
      }
    }

    // BFS order
    bfsOrder = [];
    var bq = [0];
    var visited = {};
    visited[0] = true;
    while (bq.length > 0) {
      var nid = bq.shift();
      bfsOrder.push(nid);
      var ch = nodes[nid].children;
      for (var ci = 0; ci < ch.length; ci++) {
        if (!visited[ch[ci]]) {
          visited[ch[ci]] = true;
          bq.push(ch[ci]);
        }
      }
    }
  }

  // --- Layout ---
  function layoutTree() {
    if (nodes.length === 0) { return; }
    var nw = nodeWidth();
    var maxDepth = 0;
    var levels = {};
    for (var i = 0; i < nodes.length; i++) {
      var d = nodes[i].depth;
      if (d > maxDepth) { maxDepth = d; }
      if (!levels[d]) { levels[d] = []; }
      levels[d].push(i);
    }

    var areaX = w * (1 - 2 * PAD_X);
    var areaY = h * (1 - 2 * PAD_Y);
    var startX = w * PAD_X;
    var startY = h * PAD_Y;
    var levelH = maxDepth > 0 ? areaY / maxDepth : 0;

    // barycenter ordering (except root)
    for (var dd = 1; dd <= maxDepth; dd++) {
      if (!levels[dd]) { continue; }
      levels[dd].sort(function(a, b) {
        var pa = nodes[nodes[a].parentId];
        var pb = nodes[nodes[b].parentId];
        return (pa ? pa.x : 0) - (pb ? pb.x : 0);
      });
    }

    // assign positions
    for (var dl = 0; dl <= maxDepth; dl++) {
      var lvl = levels[dl];
      if (!lvl) { continue; }
      var n = lvl.length;
      var spacing = areaX / (n + 1);
      for (var li = 0; li < n; li++) {
        var node = nodes[lvl[li]];
        node.x = startX + spacing * (li + 1) + (Math.random() - 0.5) * 10;
        node.y = startY + levelH * dl + (Math.random() - 0.5) * 8;
      }
    }
  }

  // --- Helpers ---
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
  function easeInQuad(t) { return t * t; }
  function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }

  function quadBezier(x0, y0, cx, cy, x1, y1, t) {
    var m = 1 - t;
    return {
      x: m * m * x0 + 2 * m * t * cx + t * t * x1,
      y: m * m * y0 + 2 * m * t * cy + t * t * y1
    };
  }

  // --- Update ---
  function update(now) {
    var elapsed = now - phaseStart;

    if (phase === 'GENERATE') {
      generateTree();
      layoutTree();
      globalAlpha = 1;
      phase = 'BUILD';
      phaseStart = now;
      elapsed = 0;
    }

    if (phase === 'BUILD') {
      var allDone = true;
      for (var bi = 0; bi < bfsOrder.length; bi++) {
        var nid = bfsOrder[bi];
        var nodeStart = bi * BUILD_STAGGER;
        var t = clamp((elapsed - nodeStart) / NODE_APPEAR, 0, 1);
        var et = easeOutCubic(t);
        nodes[nid].opacity = et;
        nodes[nid].scale = 0.5 + 0.5 * et;
        if (t < 1) { allDone = false; }
      }
      for (var ei = 0; ei < edges.length; ei++) {
        var edge = edges[ei];
        var childIdx = -1;
        for (var si = 0; si < bfsOrder.length; si++) {
          if (bfsOrder[si] === edge.to) { childIdx = si; break; }
        }
        if (childIdx < 0) { childIdx = bfsOrder.length - 1; }
        var edgeStart = childIdx * BUILD_STAGGER - 100;
        if (edge.cross) { edgeStart = bfsOrder.length * BUILD_STAGGER; }
        edge.progress = clamp((elapsed - edgeStart) / EDGE_DRAW, 0, 1);
        if (edge.progress < 1) { allDone = false; }
      }
      if (allDone) {
        phase = 'HOLD';
        phaseStart = now;
      }
    } else if (phase === 'HOLD') {
      if (elapsed > HOLD_MS) {
        phase = 'FADE_OUT';
        phaseStart = now;
      }
    } else if (phase === 'FADE_OUT') {
      var ft = clamp(elapsed / FADE_MS, 0, 1);
      globalAlpha = 1 - easeInQuad(ft);
      if (ft >= 1) {
        phase = 'GENERATE';
        phaseStart = now;
      }
    }
  }

  // --- Draw ---
  function drawEdge(edge) {
    if (edge.progress <= 0) { return; }
    var from = nodes[edge.from];
    var to = nodes[edge.to];
    if (!from || !to) { return; }

    var isDark = document.documentElement.getAttribute('data-theme') !== 'light';
    var strokeColor = isDark ? 'rgba(200, 200, 220, 0.25)' : 'rgba(40, 40, 60, 0.2)';

    var x0 = from.x, y0 = from.y + NODE_H / 2;
    var x1 = to.x, y1 = to.y - NODE_H / 2;
    var cpx = (x0 + x1) / 2 + (x1 - x0) * 0.1;
    var cpy = (y0 + y1) / 2;

    ctx.save();
    ctx.strokeStyle = strokeColor;
    ctx.lineWidth = 1;
    ctx.lineCap = 'round';

    if (edge.cross) {
      ctx.setLineDash([4, 4]);
    }

    if (edge.progress < 1) {
      // draw partial bezier
      var steps = 20;
      var maxT = edge.progress;
      ctx.beginPath();
      var p0 = quadBezier(x0, y0, cpx, cpy, x1, y1, 0);
      ctx.moveTo(p0.x, p0.y);
      for (var s = 1; s <= steps; s++) {
        var st = (s / steps) * maxT;
        var pt = quadBezier(x0, y0, cpx, cpy, x1, y1, st);
        ctx.lineTo(pt.x, pt.y);
      }
      ctx.stroke();
    } else {
      ctx.beginPath();
      ctx.moveTo(x0, y0);
      ctx.quadraticCurveTo(cpx, cpy, x1, y1);
      ctx.stroke();

      // arrowhead
      var at = quadBezier(x0, y0, cpx, cpy, x1, y1, 0.95);
      var angle = Math.atan2(y1 - at.y, x1 - at.x);
      var aSize = 4;
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x1 - aSize * Math.cos(angle - 0.4), y1 - aSize * Math.sin(angle - 0.4));
      ctx.moveTo(x1, y1);
      ctx.lineTo(x1 - aSize * Math.cos(angle + 0.4), y1 - aSize * Math.sin(angle + 0.4));
      ctx.stroke();
    }

    ctx.restore();
  }

  function drawNode(node) {
    if (node.opacity <= 0) { return; }

    var isDark = document.documentElement.getAttribute('data-theme') !== 'light';
    var nw = nodeWidth();
    var nx = node.x - (nw * node.scale) / 2;
    var ny = node.y - (NODE_H * node.scale) / 2;
    var rw = nw * node.scale;
    var rh = NODE_H * node.scale;

    ctx.save();
    ctx.globalAlpha = ctx.globalAlpha * node.opacity;

    // glow
    var holdPulse = 0;
    if (phase === 'HOLD') {
      holdPulse = Math.sin((phaseStart ? (performance.now() - phaseStart) / 600 : 0) + node.id * 0.7) * 3;
    }
    ctx.shadowBlur = 8 + holdPulse;
    ctx.shadowColor = isDark ? 'rgba(26, 122, 155, 0.3)' : 'rgba(26, 107, 138, 0.2)';

    // fill
    ctx.fillStyle = isDark ? 'rgba(26, 122, 155, 0.15)' : 'rgba(26, 107, 138, 0.10)';
    ctx.strokeStyle = isDark ? 'rgba(26, 122, 155, 0.6)' : 'rgba(26, 107, 138, 0.5)';
    ctx.lineWidth = 1;

    // rounded rect
    ctx.beginPath();
    ctx.moveTo(nx + NODE_R, ny);
    ctx.lineTo(nx + rw - NODE_R, ny);
    ctx.arcTo(nx + rw, ny, nx + rw, ny + NODE_R, NODE_R);
    ctx.lineTo(nx + rw, ny + rh - NODE_R);
    ctx.arcTo(nx + rw, ny + rh, nx + rw - NODE_R, ny + rh, NODE_R);
    ctx.lineTo(nx + NODE_R, ny + rh);
    ctx.arcTo(nx, ny + rh, nx, ny + rh - NODE_R, NODE_R);
    ctx.lineTo(nx, ny + NODE_R);
    ctx.arcTo(nx, ny, nx + NODE_R, ny, NODE_R);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();

    // reset shadow before text
    ctx.shadowBlur = 0;
    ctx.shadowColor = 'transparent';

    // label
    var fontSize = Math.round(9 * node.scale);
    if (fontSize >= 6) {
      ctx.font = fontSize + 'px "Geist Mono", ui-monospace, monospace';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = isDark ? 'rgba(200, 200, 220, 0.6)' : 'rgba(40, 40, 60, 0.5)';
      ctx.fillText(node.label, node.x, node.y);
    }

    ctx.restore();
  }

  function draw(now) {
    if (!lastTime) { lastTime = now; }
    // handle tab switch (big time jump)
    if (now - lastTime > 500) {
      phase = 'GENERATE';
      phaseStart = now;
    }
    lastTime = now;

    update(now);
    ctx.clearRect(0, 0, w, h);
    ctx.globalAlpha = globalAlpha;

    for (var ei = 0; ei < edges.length; ei++) {
      drawEdge(edges[ei]);
    }
    for (var ni = 0; ni < nodes.length; ni++) {
      drawNode(nodes[ni]);
    }

    ctx.globalAlpha = 1;
    requestAnimationFrame(draw);
  }

  function init() {
    resize();
    phase = 'GENERATE';
    phaseStart = performance.now();
  }

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      resize();
      layoutTree();
    }, 150);
  });

  if (canvas.offsetWidth > 0) {
    init();
    requestAnimationFrame(draw);
  } else {
    window.addEventListener('load', function() {
      init();
      requestAnimationFrame(draw);
    });
  }
})();
